import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-followups',
  templateUrl: './followups.component.html',
  styleUrls: ['./followups.component.scss']
})
export class FollowupsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
